import { PharmacySelect } from '@ui/checkout/pharmacy-select';
import { PharmacyCard } from '@ui/checkout/pharmacy-card';
import { useNavigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import {
  checkoutAtom,
  productsAtom,
} from '../../cart/use-cart-products.store.ts';
import { useStoresList } from '../../store/use-stores-list.ts';
import { cityAtom } from '@app/atoms/app/city.atom.ts';
import { ProductStatusProps } from '@ui/product/product-status.tsx';
import { useEffect } from 'react';
import { useAtom } from 'jotai/index';

export const SelfPickup = () => {
  const navigate = useNavigate();
  const [checkout, setCheckout] = useAtom(checkoutAtom);
  const cart = useAtomValue(productsAtom);
  const city = useAtomValue(cityAtom);
  const { rawData = [] } = useStoresList({
    selectedProductId: cart.map((i) => i.id),
    selectedCityId: city.id,
  });
  const builder = () => {
    if (!checkout.pharmacyId) return null;

    const info = rawData
      .map((pharmacy) => {
        return {
          id: pharmacy.id,
          address: pharmacy.address,
          name: `Аптека №${pharmacy.id}`,
          variant: 'edit',
          statuses: [
            { variant: 'open', children: 'Открыто с 10:00 до 00:00' },
            { variant: 'available' },
          ] as ProductStatusProps[],
          onPress: () => navigate('/pharmacy'),
          // onPress: () => navigate('/pharmacy'),
        } as const;
      })
      .find((item) => item.id === checkout.pharmacyId);

    return info || null;
  };

  const info = builder();

  useEffect(() => {
    if (!checkout.pharmacyId && rawData.length > 0) {
      setCheckout((s) => ({
        ...s,
        pharmacyId: rawData[0].id,
      }));
    }
  }, [checkout.pharmacyId, rawData]);

  return (
    <>
      {!info && <PharmacySelect onPress={() => navigate('/pharmacy')} />}

      {info && (
        <div className="border rounded-xl p-4">
          <PharmacyCard
            name={info.name}
            address={info.address}
            variant={info.variant}
            statuses={info.statuses}
            onPress={() => navigate('/pharmacy')}
          />
        </div>
      )}
    </>
  );
};
